import { memo, useReducer } from "react"
import { StateProp } from "../../../contexts/types"
import { flotiMapReducer, initial_flotiMap } from "./reducer"
import FlotiMapContext from "./context"

const FlotiMapState = memo(({ children }: StateProp) => {
  const [flotiMap, dispatch] = useReducer(flotiMapReducer, initial_flotiMap)

  return (
    <FlotiMapContext.Provider value={{ flotiMap, dispatch }}>
      {children}
    </FlotiMapContext.Provider>
  )
})

export default FlotiMapState
